import { useState } from "react";

interface Props {
  inviteToken: string;
}

export function InviteLink({ inviteToken }: Props) {
  const [copied, setCopied] = useState(false);

  const url = `${window.location.origin}/s/${inviteToken}`;

  function copy() {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  function shareWhatsApp() {
    const text = encodeURIComponent(
      `Add your location so we can find a fair meeting point: ${url}`,
    );
    window.open(`https://wa.me/?text=${text}`, "_blank", "noopener");
  }

  return (
    <div className="card invite-card">
      <h2>Invite friends</h2>
      <p className="muted small">
        Share this link — everyone adds their own location.
      </p>
      <div className="invite-url-row">
        <input
          className="invite-url"
          value={url}
          readOnly
          onClick={(e) => (e.target as HTMLInputElement).select()}
        />
      </div>
      <div className="invite-actions">
        <button type="button" className="primary" onClick={copy}>
          {copied ? "Copied!" : "Copy link"}
        </button>
        <button type="button" onClick={shareWhatsApp}>
          Share on WhatsApp
        </button>
      </div>
    </div>
  );
}
